import React from 'react';
import FoldHome from '../../components/FoldHome';
import WhatIsDC from '../../components/WhatIsDC';
import Repertoire from '../../components/Repertoire';
import SectionTitle from '../../components/SectionTitle';
import ExampleCarousel from '../../components/ExampleCarousel';
import HowItWorks from '../../components/HowItWorks';
import ChooseDesigner from '../../components/ChooseDesigner';
import ChargeSoLittle from '../../components/ChargeSoLittle';
import OtherOptions from '../../components/OtherOptions';
import OfferingImages from '../../components/OfferingImages';
import Examples from '../../components/Examples';
import Designers from '../../components/Designers';
import HomeFooter from '../../components/HomeFooter';
import Faq from '../../components/Faq';

function Home ({
  showModal,
  anchorTo,
  submitSuccess
}) {

  return (
    <div>
      <div className="fold-container">
        <FoldHome />
      </div>
      <div className="container-fluid main-container">
        <div className="col-md-10 col-md-offset-1 col-sm-12">
          <Repertoire />
        </div>
      </div>
      <hr />
      <SectionTitle color="#5CC3FF">
        EXAMPLE WORK
      </SectionTitle>
      <div className="mt100" />
      <ExampleCarousel link="/talent" />
      <div className="mt100" />
      <div className="container-fluid main-container">
        <div className="col-md-10 col-md-offset-1 col-sm-12">
          <WhatIsDC />
        </div>
      </div>
      <hr />
      <div className="container-fluid main-container">
        <div className="col-md-10 col-md-offset-1 col-sm-12">
          <HowItWorks />
          <div className="mb100">&nbsp;</div>
          <ChooseDesigner />
        </div>
      </div>
      <hr />
      <div className="container-fluid main-container">
        <div className="col-md-10 col-md-offset-1 col-sm-12">
          <Examples />
        </div>
      </div>
      <hr />
      <div className="container-fluid main-container">
        <div className="col-md-10 col-md-offset-1 col-sm-12">
          <Designers />
        </div>
      </div>
      <hr />
      <div className="container-fluid main-container">
        <div className="col-md-10 col-md-offset-1 col-sm-12">
          <ChargeSoLittle />
          <div className="mt100" />
          <OtherOptions />
        </div>
      </div>
      <hr />
      <div className="container-fluid main-container">
        <div className="col-md-10 col-md-offset-1 col-sm-12">
          <Faq />
        </div>
      </div>
      <hr />
      <div className="container-fluid main-container">
        <div className="col-md-10 col-md-offset-1 col-sm-12">
          <OfferingImages />
        </div>
      </div>
      <hr className="bg-below"/>
      <HomeFooter />
    </div>
  );
}

export default Home;



// WEBPACK FOOTER //
// ./src/pages/Home/index.js